import Vue from 'vue';
import VueI18n from 'vue-i18n';

import ptBR from '../locales/pt-BR.json';
import en from '../locales/en.json';
import es from '../locales/es.json';

Vue.use(VueI18n);

const DEFAULT_LOCALE = 'pt-BR';
const storedLocale = localStorage.getItem('app-locale') || DEFAULT_LOCALE;

export const i18n = new VueI18n({
    locale: storedLocale,
    fallbackLocale: DEFAULT_LOCALE,
    messages: {
        'pt-BR': ptBR,
        'en': en,
        'es': es
    }
});

export function setLocale(locale) {
    i18n.locale = locale;
    localStorage.setItem('app-locale', locale);
    document.querySelector('html').setAttribute('lang', locale);
}



// WEBPACK FOOTER //
// ./src/plugins/i18n.js